// extracted by mini-css-extract-plugin
export var black = "_1d-6";
export var brand = "_1d-1";
export var ddefault = "_1d-0";
export var error = "_1d-3";
export var gray = "_1d-2";
export var highContrast = "_1d-8";
export var outline = "_1d-7";
export var success = "_1d-5";
export var warning = "_1d-4";